module.exports = __webpack_public_path__ + "statics/img/qcs_A.png";